import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useArchiveFile } from "../hooks";
import { ViewerArchiveContainer } from "../viewer/container";
import { ViewArchiveInfoError, ViewArchiveInfoLoadingIcon } from "../viewer/status";
export const ViewArchiveFile = props => {
  const {
    archive,
    name,
    children
  } = props;
  const [file, {
    loading,
    error
  }] = useArchiveFile(archive, name);
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && !file ? /*#__PURE__*/React.createElement(ViewerArchiveContainer, null, /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: name !== null && name !== void 0 ? name : undefined
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, error ? /*#__PURE__*/React.createElement(ViewerArchiveContainer, null, /*#__PURE__*/React.createElement(ViewArchiveInfoError, null, "Error parsing archive to file")) : /*#__PURE__*/React.createElement(React.Fragment, null, file && children && children(file))));
};